import { render, staticRenderFns } from "./PaginaContributiSponsorship.vue?vue&type=template&id=d9547ec0"
import script from "./PaginaContributiSponsorship.vue?vue&type=script&lang=js"
export * from "./PaginaContributiSponsorship.vue?vue&type=script&lang=js"
import style0 from "./PaginaContributiSponsorship.vue?vue&type=style&index=0&id=d9547ec0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports